var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999836,18.0002 L13.9999836,18.0002 L13.9999836,13.0002 C13.9999836,12.4482 13.5519836,12.0002 12.9999836,12.0002 L6.99998362,12.0002 C6.44798362,12.0002 5.99998362,12.4482 5.99998362,13.0002 L5.99998362,18.0002 L3.99998362,18.0002 L3.99998362,7.6712 L9.99998362,2.3382 L15.9999836,7.6712 L15.9999836,18.0002 Z M3.99998362,2.0002 L5.99998362,2.0002 L5.99998362,3.2172 L3.99998362,4.9952 L3.99998362,2.0002 Z M19.6649836,8.2522 L10.6649836,0.2522 C10.2859836,-0.0838 9.71398362,-0.0838 9.33498362,0.2522 L7.99998362,1.4392 L7.99998362,1.0002 C7.99998362,0.4482 7.55198362,0.0002 6.99998362,0.0002 L2.99998362,0.0002 C2.44798362,0.0002 1.99998362,0.4482 1.99998362,1.0002 L1.99998362,6.7732 L0.334983616,8.2522 C-0.0770163836,8.6202 -0.114016384,9.2512 0.251983616,9.6652 C0.619983616,10.0782 1.24998362,10.1142 1.66498362,9.7482 L1.99998362,9.4492 L1.99998362,19.0002 C1.99998362,19.5522 2.44798362,20.0002 2.99998362,20.0002 L6.99998362,20.0002 C7.55198362,20.0002 7.99998362,19.5522 7.99998362,19.0002 L7.99998362,14.0002 L11.9999836,14.0002 L11.9999836,19.0002 C11.9999836,19.5522 12.4479836,20.0002 12.9999836,20.0002 L16.9999836,20.0002 C17.5519836,20.0002 17.9999836,19.5522 17.9999836,19.0002 L17.9999836,9.4492 L18.3349836,9.7482 C18.5259836,9.9172 18.7629836,10.0002 18.9999836,10.0002 C19.2749836,10.0002 19.5499836,9.8872 19.7479836,9.6652 C20.1139836,9.2512 20.0769836,8.6202 19.6649836,8.2522 L19.6649836,8.2522 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Library",
    transform: "translate(-42.000000, -90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "side-nav",
    transform: "translate(42.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon",
    fill: "#919EAB",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.509f3afb904c1448fb0b80e2f01f27ae.svg";
export { ForwardRef as ReactComponent };